import { ContactField } from 'src/editor/api/contact-fields-api'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { LocoAssetsKeysType } from 'src/shared/i18next/types/loco-assets-keys-type'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'

export const contactFieldLocoKeys: Record<ContactSlugEnum, LocoAssetsKeysType> =
  {
    [ContactSlugEnum.Email]: 'core.contact_slug.email',
    [ContactSlugEnum.FirstName]: 'core.contact_slug.first_name',
    [ContactSlugEnum.Surname]: 'core.contact_slug.last_name',
    [ContactSlugEnum.PhoneNumber]: 'core.contact_slug.phone_number',
    [ContactSlugEnum.Country]: 'core.contact_slug.country',
    [ContactSlugEnum.Neighborhood]: 'core.contact_slug.neighborhood',
    [ContactSlugEnum.StreetAddress]: 'core.contact_slug.street_address',
    [ContactSlugEnum.StreetNumber]: 'core.contact_slug.street_number',
    [ContactSlugEnum.City]: 'core.contact_slug.city',
    [ContactSlugEnum.Postcode]: 'core.contact_slug.postal_code',
    [ContactSlugEnum.CompanyName]: 'core.contact_slug.company_name',
    [ContactSlugEnum.TaxNumber]: 'core.contact_slug.tax_number',
    [ContactSlugEnum.State]: 'core.contact_slug.state_province',
  }

export const getContactSlugName = (
  slug: ContactSlugEnum,
  t: TypedTFunctionInterface,
) => t(contactFieldLocoKeys[slug])

export const getContactFieldTitle = (
  contactField: Pick<ContactField, 'fieldName' | 'slug'>,
  t: TypedTFunctionInterface,
) => {
  const { slug, fieldName } = contactField

  if (Object.values(ContactSlugEnum).includes(slug as ContactSlugEnum)) {
    return getContactSlugName(slug as ContactSlugEnum, t)
  }

  return fieldName
}
